/**
 * Canonical breakpoint values (px) — single source of truth for NEW
 * responsive logic (useBreakpoint, BasePageView). Existing usages in
 * theme.js / variables.scss / ad hoc window.innerWidth checks are
 * untouched — those migrate later, deliberately, out of scope here.
 */
export const BREAKPOINTS = {
  mobile: 768, // <768px = mobile
  tablet: 992,
  desktop: 1200,
};

export const MEDIA_QUERIES = {
  mobile: `(max-width: ${BREAKPOINTS.mobile - 1}px)`,
  tabletUp: `(min-width: ${BREAKPOINTS.mobile}px)`,
  desktopUp: `(min-width: ${BREAKPOINTS.tablet}px)`,
  wideUp: `(min-width: ${BREAKPOINTS.desktop}px)`,
};

export default BREAKPOINTS;
